export const rightsLabel = 'All rights reserved.';

export const EMPTY_STATUS = '';
export const ACTIVE = 'Active';
export const INACTIVE = 'Inactive';
export const SCHEDULED = 'Scheduled';
export const COMPLETED = 'Completed';

export const REFRESH_LABEL = 'Refresh';
export const GO_TO_DASHBOARD = 'Go to Dashboard';
export const DASHBOARD = 'Dashboard';
export const EMPLOYEES = 'Employees';
export const PROGRAMS = 'Programs';
export const PAYMENTS = 'Payments';
export const REMOVED_EXITED = 'REMOVED_EXITED';
export const EXITED = 'EXITED';
export const ONLINE_PAYMENT_ERROR = 'Try again later';
export const ONLINE = 'ONLINE';
export const FORCESERVER = 'forceserver';

export const getCurrentMonth = () => {
  const date = new Date();
  switch (date.getMonth()) {
    case 0:
      return 'January';
    case 1:
      return 'February';
    case 2:
      return 'March';
    case 3:
      return 'April';
    case 4:
      return 'May';
    case 5:
      return 'June';
    case 6:
      return 'July';
    case 7:
      return 'August';
    case 8:
      return 'September';
    case 9:
      return 'October';
    case 10:
      return 'November';
    case 11:
      return 'December';
    default:
      return '';
  }
};

export const sourceToCreditType = source => {
  switch (source) {
    case 'system':
      return 'Released';
    case 'online':
      return 'Online';
    case 'spoc':
      return 'Bank transfer';
    case 'admin':
      return 'Bank transfer';
    default:
      return ' - ';
  }
};

export const statusLabels = {
  true: 'ACTIVE',
  false: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  INVITED: 'INVITED',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  PENDING: 'PENDING',
  DECLINED: 'DECLINED',
  INITIATED: 'INITITATED',
  PAUSED: 'PAUSED',
  DELETED: 'DELETED',
  EXPIRED: 'EXPIRED',
  NOT_STARTED: 'NOT STARTED',
  DRAFTED: 'DRAFTED',
  COMPLETED: 'COMPLETED',
  PLAN_ACTIVE: 'ACTIVE',
  ADDED: 'ADDED',
  OPTED_IN: 'OPTED IN',
  REMOVED: 'REMOVED',
  ON_HOLD: 'ON HOLD',
  EXITED: 'EXITED',
  0: 'INACTIVE',
  1: 'ACTIVE',
  3: 'SCHEDULED',
  4: 'COMPLETED',
  Completed: 'COMPLETED',
  COMPLETED_ENDED: 'ENDED',
  Inactive: 'INACTIVE',
  default: '',
  ENQUEUED: 'ENQUEUED',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT FUNDS',
  GENERATED: 'GENERATED',
  GENERATED_SCHEDULED: 'SCHEDULED',
  GENERATED_UPCOMING: 'UPCOMING',
  FUNDS_AWAITED_AMOUNT_DUE: 'AMOUNT DUE',
  SCHEDULED: 'SCHEDULED',
  SCHEDULED_AMOUNT_PARKED: 'AMOUNT PARKED',
  PROCESSING_IN_PROGRESS: 'IN PROGRESS',
  PARTIALLY_DONE: 'PARTIALLY DONE',
  COMPLETED_SUCCESS: 'SUCCESS',
  INITIATED_PROCESSING: 'PROCESSING',
  UNSPECIFIED: 'UNSPECIFIED',
  NO_ACTIVE_WALLET: 'NO ACTIVE WALLET',
  TIMEOUT: 'TIMEOUT',
  PAYMENT_ERROR: 'PAYMENT ERROR',
  DB_FAILURE: 'DB FAILURE',
  NOT_LINKED: 'NOT LINKED',
  TERMINATED: 'TERMINATED',
  INACTIVE_EMPLOYEE: 'INACTIVE EMPLOYEE',
  INACTIVE_EMPLOYEE_GROUP_MAPPING: 'INACTIVE EMPLOYEE GROUP MAPPING',
  DUPLICATE_ATTEMPT: 'DUPLICATE ATTEMPT',
  INVALID_STATUS: 'INVALID STATUS',
  INVALID_SUBSCRIPTION: 'INVALID SUBSCRIPTION',
  CREDITS_EXPIRED: 'CREDITS EXPIRED',
  MOVED_PARKED_FUNDS: 'MOVED PARKED FUNDS',
  FAILED: 'FAILED',
  WALLET_CREATION_PENDING_ONBOARDING_PENDING: 'ONBOARDING PENDING',
  PENDING_WITH_PARTNER_PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  SYSTEM_FAILED_PROCESSING: 'PROCESSING',
  ACCUMULATING: 'ACCUMULATING',
  NON_ACCUMULATING: 'NON ACCUMULATING',
  EXECUTION: 'Plan execution',
  ADDITION: 'Employee addition',
  DEBIT: 'DEBIT',
  CREDIT: 'CREDIT',
  TRANSACTION_SUCCESS: 'SUCCESS',
  TRANSACTION_FAILED: 'FAILED',
  TRANSACTION_EXPIRED_FAILED: 'FAILED',
  ADDED_ONBOARDING_PENDING: 'ONBOARDING PENDING',
  OPTED_IN_ONBOARDING_INCOMPLETE: 'ONBOARDING INCOMPLETE',
  REMOVED_EXITED: 'EXITED',
  TOPUP_EXPIRED_SUCCESS: 'SUCCESS',
  DELETED_SUCCESS: 'SUCCESS',
  PAUSED_SUCCESS: 'SUCCESS',
  ACTIVE_ONBOARDED: 'ONBOARDED',
  ON_HOLD_NEEDS_UPGRADE: 'NEEDS UPGRADE',
  APPROVED_SUCCESS: 'SUCCESS',
  INITIATED_PENDING: 'PENDING',
  VOID_FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'REFUNDED',
  PLACED_SUCCESS: 'SUCCESS',
  PROCESSING: 'PROCESSING',
  GENERATED_UNPAID: 'UNPAID',
  PARTIALLY_PAID: 'PARTIALLY PAID',
  PAID: 'PAID',
  SETTLED_PAID: 'PAID',
  DELIVERY: 'Delivery',
  DINING: 'Dining',
  PAYMENT_PENDING: 'PENDING',
  ORDER_PLACED_PAID: 'PAID',
  ORDER_FAILED: 'FAILED',
  ORDER_REFUNDED: 'FULL REFUND',
  ORDER_PARTIALLY_REFUNDED: 'PART REFUND',
  TEXT: 'Text',
  SINGLE_OPTION: 'Single option',
  MULTIPLE_OPTIONS: 'Multiple option',
  NUMERIC: 'Numeric',
};

export const tootipInfoLabels = {
  UNSPECIFIED: 'Unspecified',
  GENERATED_SCHEDULED: 'Transaction is scheduled. Please wait.',
  INITIATED_PROCESSING: 'Transaction is pending',
  WALLET_CREATION_PENDING_ONBOARDING_PENDING:
    'Amount will be added on onboarding',
  TRANSACTION_SUCCESS: 'Amount credited successfully',
  TRANSACTION_FAILED: 'Transaction failed',
  SYSTEM_FAILED_PENDING: 'Transaction is pending',
  TRANSACTION_EXPIRED_FAILED: 'Transaction time limit is expired',
  PENDING_WITH_PARTNER_TOPUP_PENDING: 'Amount topup is pending',
};

export const paymentRequestEnum = {
  0: 'UNSPECIFIED',
  1: 'ACTIVE',
  2: 'INACTIVE',
  3: 'EXPIRED',
  4: 'PAID',
  UNSPECIFIED: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  EXPIRED: 3,
  PAID: 4,
};

export const cycleTypeEnum = {
  0: 'UNSPECIFIED',
  1: 'WEEKLY',
  2: 'MONTHLY',
  3: 'DAILY',
  UNSPECIFIED: 0,
  WEEKLY: 1,
  MONTHLY: 2,
  DAILY: 3,
};

export const eventsAmountEnum = {
  UNSPECIFIED: 0,
  PENDING: 1,
  RELEASED: 2,
  DISPERSED: 3,
};

export const creditStatusLabels = {
  1: 'Success',
  2: 'Failed',
};

export const activateStatusLabels = {
  1: 'Active',
  0: 'Inactive',
};

export const topupsStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'INITIATED',
  2: 'GENERATED_UPCOMING',
  3: 'FUNDS_AWAITED_AMOUNT_DUE',
  4: 'SCHEDULED_AMOUNT_PARKED',
  5: 'PROCESSING_IN_PROGRESS',
  6: 'PARTIALLY_DONE',
  7: 'FAILED',
  8: 'TOPUP_EXPIRED_SUCCESS',
  9: 'COMPLETED_SUCCESS',
  10: 'DELETED_SUCCESS',
  11: 'PAUSED_SUCCESS',
  UNSPECIFIED: 0,
  INITIATED: 1,
  GENERATED_UPCOMING: 2,
  FUNDS_AWAITED_AMOUNT_DUE: 3,
  SCHEDULED_AMOUNT_PARKED: 4,
  PROCESSING_IN_PROGRESS: 5,
  PARTIALLY_DONE: 6,
  FAILED: 7,
  TOPUP_EXPIRED_SUCCESS: 8,
  COMPLETED_SUCCESS: 9,
  DELETED_SUCCESS: 10,
  PAUSED_SUCCESS: 11,
};

export const orderStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'ORDER_PLACED_PAID',
  2: 'ORDER_FAILED',
  3: 'ORDER_REFUNDED',
  4: 'ORDER_PARTIALLY_REFUNDED',
  UNSPECIFIED: 0,
  ORDER_PLACED_PAID: 1,
  ORDER_FAILED: 2,
  ORDER_REFUNDED: 3,
  ORDER_PARTIALLY_REFUNDED: 4,
};

export const orderServiceTypeEnum = {
  0: 'UNSPECIFIED',
  1: 'DELIVERY',
  2: 'DINING',
  UNSPECIFIED: 0,
  DELIVERY: 1,
  DINING: 2,
};

export const invoicesStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'INITIATED_PROCESSING',
  2: 'PROCESSING',
  3: 'GENERATED_UNPAID',
  4: 'PARTIALLY_PAID',
  5: 'PAID',
  6: 'SETTLED_PAID',
  7: 'PAYMENT_PENDING',
  UNSPECIFIED: 0,
  INITIATED_PROCESSING: 1,
  PROCESSING: 2,
  GENERATED_UNPAID: 3,
  PARTIALLY_PAID: 4,
  PAID: 5,
  SETTLED_PAID: 6,
  PAYMENT_PENDING: 7,
};

export const questionStatusEnum = {
  0: 'INITIATED',
  1: 'ACTIVE',
  2: 'INACTIVE',
  INITIATED: 0,
  ACTIVE: 1,
  INACTIVE: 2,
};

export const questionTypeEnum = {
  0: 'UNKNOWN',
  1: 'TEXT',
  2: 'SINGLE_OPTION',
  3: 'MULTIPLE_OPTIONS',
  4: 'NUMERIC',
  UNKNOWN: 0,
  TEXT: 1,
  SINGLE_OPTION: 2,
  MULTIPLE_OPTIONS: 3,
  NUMERIC: 4,
};

export const topupTypeStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'ACCUMULATING',
  2: 'NON_ACCUMULATING',
  UNSPECIFIED: 0,
  ACCUMULATING: 1,
  NON_ACCUMULATING: 2,
};

export const topupEventTypeStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'EXECUTION',
  2: 'ADDITION',
  UNSPECIFIED: 0,
  EXECUTION: 1,
  ADDITION: 2,
};

export const employeeStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'ADDED_ONBOARDING_PENDING',
  2: 'OPTED_IN_ONBOARDING_INCOMPLETE',
  3: 'REMOVED_EXITED',
  4: 'EXITED',
  5: 'ACTIVE_ONBOARDED',
  6: 'ON_HOLD_NEEDS_UPGRADE',
  UNSPECIFIED: 0,
  ADDED_ONBOARDING_PENDING: 1,
  OPTED_IN_ONBOARDING_INCOMPLETE: 2,
  REMOVED_EXITED: 3,
  EXITED: 4,
  ACTIVE_ONBOARDED: 5,
  ON_HOLD_NEEDS_UPGRADE: 6,
};

export const programStatusEnum = {
  0: 'DRAFTED',
  1: 'PLAN_ACTIVE',
  2: 'PAUSED',
  3: 'DELETED',
  4: 'COMPLETED_ENDED',
  5: 'NOT_STARTED',
  DRAFTED: 0,
  PLAN_ACTIVE: 1,
  PAUSED: 2,
  DELETED: 3,
  COMPLETED_ENDED: 4,
  NOT_STARTED: 5,
};

export const paymentStatusEnum = {
  0: 'INITIATED_PENDING',
  1: 'APPROVED_SUCCESS',
  2: 'DECLINED',
  3: 'VOID_FAILED',
  4: 'SUCCESS',
  5: 'FAILED',
  6: 'PENDING',
  7: 'REFUNDED',
  8: 'PARTIALLY_REFUNDED',
  INITIATED_PENDING: 0,
  APPROVED_SUCCESS: 1,
  DECLINED: 2,
  VOID_FAILED: 3,
  SUCCESS: 4,
  FAILED: 5,
  PENDING: 6,
  REFUNDED: 7,
  PARTIALLY_REFUNDED: 8,
};

export const creditTransactionsStatusEnum = {
  0: 'UNSPECIFIED',
  1: 'GENERATED_SCHEDULED',
  2: 'INITIATED_PROCESSING',
  3: 'WALLET_CREATION_PENDING_ONBOARDING_PENDING',
  4: 'TRANSACTION_SUCCESS',
  5: 'TRANSACTION_FAILED',
  6: 'SYSTEM_FAILED_PROCESSING',
  7: 'TRANSACTION_EXPIRED_FAILED',
  8: 'PENDING_WITH_PARTNER_PROCESSING',
  UNSPECIFIED: 0,
  GENERATED_SCHEDULED: 1,
  INITIATED_PROCESSING: 2,
  WALLET_CREATION_PENDING_ONBOARDING_PENDING: 3,
  TRANSACTION_SUCCESS: 4,
  TRANSACTION_FAILED: 5,
  SYSTEM_FAILED_PROCESSING: 6,
  TRANSACTION_EXPIRED_FAILED: 7,
  PENDING_WITH_PARTNER_PROCESSING: 8,
};

export const reasonCreditTransactionEnum = {
  0: 'UNSPECIFIED',
  1: 'NO_ACTIVE_WALLET',
  2: 'TIMEOUT',
  3: 'PAYMENT_ERROR',
  4: 'DB_FAILURE',
  5: 'NOT_LINKED',
  6: 'TERMINATED',
  7: 'FAILED',
  8: 'INACTIVE_EMPLOYEE',
  9: 'INACTIVE_EMPLOYEE_GROUP_MAPPING',
  10: 'DUPLICATE_ATTEMPT',
  11: 'INVALID_STATUS',
  12: 'INVALID_SUBSCRIPTION',
  13: 'CREDITS_EXPIRED',
  14: 'MOVED_PARKED_FUNDS',
  UNSPECIFIED: 0,
  NO_ACTIVE_WALLET: 1,
  TIMEOUT: 2,
  PAYMENT_ERROR: 3,
  DB_FAILURE: 4,
  NOT_LINKED: 5,
  TERMINATED: 6,
  FAILED: 7,
  INACTIVE_EMPLOYEE: 8,
  INACTIVE_EMPLOYEE_GROUP_MAPPING: 9,
  DUPLICATE_ATTEMPT: 10,
  INVALID_STATUS: 11,
  INVALID_SUBSCRIPTION: 12,
  CREDITS_EXPIRED: 13,
  MOVED_PARKED_FUNDS: 14,
};

export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const currentFlowTypeEnum = {
  0: 'FLOW_TYPE_PPI',
  1: 'FLOW_TYPE_LIMIT',
  FLOW_TYPE_PPI: 0,
  FLOW_TYPE_LIMIT: 1,
};

export const programTypeEnum = {
  0: 'PROGRAM_TYPE_UNSPECIFIED',
  1: 'PROGRAM_TYPE_RECURRING',
  2: 'PROGRAM_TYPE_ADHOC',
  PROGRAM_TYPE_UNSPECIFIED: 0,
  PROGRAM_TYPE_RECURRING: 1,
  PROGRAM_TYPE_ADHOC: 2,
};

export const applicableFlowTypes = [
  currentFlowTypeEnum.FLOW_TYPE_PPI,
  currentFlowTypeEnum.FLOW_TYPE_LIMIT,
];

export const CONFIRM_PROGRAM_DEACTIVATION = {
  title: 'Wallet program deactivated!',
  message:
    'Any ongoing credit or future credit through this program would stop immediately.',
};

export const CONFIRM_EMPLOYEE_DEACTIVATION = {
  title: 'Please confirm deactivation',
  message:
    "Once confirmed this employee won't recieve any credits from your account",
};

export const uploadSuccessStatus = ['started', 'processing', 'completed'];

export const uploadErrorStatus = ['terminated', 'failed'];

export const genericErrorMsg = 'Oops! Something went wrong.';

export const genericNotFoundMsg = 'O NO! 404 Page Not Found.';

export const invalidEmailMsg = 'Invalid Email Address';

export const invalidContactNo = 'Invalid Contact Number';

export const invalidnameMsg = 'Invalid Program Name';

export const unauthorizedMsg =
  'You are not authorized to access this website. Please check your email for verification/authorization link.';

export const wrongFormat = 'Upload a .csv not more than 5 MB';

export const employeeUploadMsg =
  'Uploading employees details CSV... Please wait! This usually takes a few minutes.';
export const paymentsUploadMsg =
  'Uploading employees details CSV... Please wait! This usually takes a few minutes.';
export const groupUploadMsg =
  'Adding employees to group... Please wait! This usually takes a few minutes.';
export const groupUploadErrMsg = 'An error occurred during file upload';

export const RESEND_EXHAUST = 'Resend attempts exhausted';
export const SUBMIT_EXHAUST =
  'OTP attempts exhausted. Please create the program again';
export const currentBalanceInfo = 'Available for future top-ups';
export const totalLimitsInfo = 'Maximum limit that can be availed';
export const limitConsumedInfo = 'Limit consumed in this month';
export const ordersPlacedInfo = 'Orders placed in this month';
export const ordersPlacingEmployeesInfo =
  'Employees who placed at least one order in this month';
export const availableLimitsInfo =
  'Total Available Limit to be used by employees';
export const amountDisbursedInfo = `Amount transferred to the employees from 1st ${getCurrentMonth()} till date`;
export const amountBlockedInfo =
  'Amount reserved for pending and upcoming top-ups';
export const amountConsumedInfo = `Amount used by employees to place orders from 1st ${getCurrentMonth()} till date`;
export const onboardingPendingInfo =
  'No. of employees yet to complete onboarding on Zomato App';
export const onboardedEmployeeInfoHomePage =
  'No. of employees who have completed onboarding on Zomato App';
export const activelyOrderingEmployeeInfoHomePage =
  'No. of employees who have placed an order';
export const activeEmployeesInfo =
  'Number of employees currently active in the company';
export const exitedEmployeesInfo = 'Exited / Added till date';
export const onboardedEmployeesInfo =
  'Completed onboarding on Zomato App / Added till date';
export const onboardingPendingEmployeesInfo =
  'Yet to complete onboarding on Zomato App / Added till date';
export const amountParkedEventDetailsPageInfo =
  'Amount that will be sent after employee onboarding';
export const amountToppedUpEventDetailsPageInfo =
  'Total amount sent successfully to employees';
export const topupDateEventDetailsPageInfo =
  'Date on which the top-ups were scheduled';
export const invoiceAmountGreaterThanPending =
  'Amount cannot be greater than pending amount';
export const invoiceAmountGreaterThan10L =
  'Payments above ₹10L cannot be made online, use bank transfer';
export const invoicePeriodTooltip = 'Period for which statement is generated';
export const invoiceAmountPayableTooltip =
  'Total amount payable for the specified period';
export const invoiceAmountPaidTooltip = 'Amount paid for this statement ';
